/*
 * @Description: 
 * @Author: jinxiaojian
 * @Email: jinxiaojian@youxin.com
 * @Date: 2019-08-20 16:31:42
 * @LastEditTime: 2019-08-25 17:14:01
 * @LastEditors: 靳肖健
 */

import Vue from 'vue'
import App from './Index.vue'
import router from './router'
import Alert from './components/alert/alert.js'
Vue.prototype.$Alert = Alert

Vue.prototype.node_config = {
  stage: process.env.VUE_APP_STAGE
}
// import Vconsole from "vconsole"
// let vConsole = new Vconsole()
// export default vConsole

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
